const forReviewActions = (state) => {
    return {
        type: "UPDATE_ACTIONS",
        state
    }
}
const forReviewApprovals = (state) => {
    return {
        type: "UPDATE_APPROVALS",
        state
    }
}

export {
    forReviewActions,
    forReviewApprovals
}
